import { formControlLabelClasses } from '@mui/material';

export const subCategoryLabelSx = {
  [`& .${formControlLabelClasses.label}`]: {
    wordBreak: 'break-word',
  },
} as const;

export const cardHeaderSx = {
  bgcolor: 'primary.main',
  color: 'primary.contrastText',
  py: 1,
  px: 2,
  borderTopLeftRadius: '20px',
  borderTopRightRadius: '20px',
  '& .MuiCheckbox-root': {
    color: 'primary.contrastText',
    '&.Mui-checked, &.MuiCheckbox-indeterminate': {
      color: 'primary.contrastText',
    },
  },
} as const;

export const titleSx = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  color: 'inherit',
} as const;
